import { logEvent } from 'firebase/analytics';

import { analytics } from '../firebaseConfig';

export const UX_TELEMETRY_EVENT = 'scribeshadow:ux-event';

type UxTelemetryValue = string | number | boolean;

const sanitizeEventName = (value: string): string =>
  value.toLowerCase().replace(/[^a-z0-9_]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40);

const sanitizeDetails = (details: Record<string, UxTelemetryValue>) =>
  Object.fromEntries(
    Object.entries(details).map(([key, value]) => [
      sanitizeEventName(key),
      typeof value === 'string' ? value.slice(0, 80) : value,
    ]),
  );

export const recordUxEvent = (
  eventName: string,
  details: Record<string, UxTelemetryValue> = {},
): void => {
  const safeEventName = sanitizeEventName(eventName);
  if (!safeEventName) return;
  const safeDetails = sanitizeDetails(details);

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(UX_TELEMETRY_EVENT, {
      detail: { eventName: safeEventName, ...safeDetails },
    }));
  }

  if (analytics) {
    try {
      logEvent(analytics, safeEventName, safeDetails);
    } catch {
      // Product workflows must never depend on analytics availability.
    }
  }
};
